import { Button, Flex } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import ListSection from "./ListSection";

const SECTION_WIDTH = 1250;

export default function DiscoveryAddApartment() {
  const { t } = useTranslation();

  return (
    <>
      <Flex id="about" direction="column" alignItems={"center"}>
        <Flex maxWidth={SECTION_WIDTH} width={"100%"} direction={"column"}>
          <ListSection
            title={t("Discovery.AddApartment.Header")}
            items={[
              {
                text: t("Discovery.AddApartment.Text1"),
              },
              {
                text: t("Discovery.AddApartment.Text2"),
              },
              {
                text: t("Discovery.AddApartment.Text3"),
              },
              {
                text: t("Discovery.AddApartment.Text4"),
              },
              {
                text: t("Discovery.AddApartment.Text5"),
              },
            ]}
          />

          <Flex justifyContent={"start"} grow={1}>
            <Button
              as="a"
              href="/short-term-rental-calculator-v2"
              target="_blank"
            >
              {t("Discovery.AddApartment.CalculateYourIncome")}
            </Button>

            <Button
              variation="primary"
              as="a"
              href="http://rentujemy.pl"
              target="_blank"
              className="hover:text-white"
            >
              {t("Discovery.AddApartment.AddApartmentInPoland")}
            </Button>
            <Button
              variation="primary"
              as="a"
              href="http://rentujemy.ae"
              target="_blank"
              className="hover:text-white"
            >
              {t("Discovery.AddApartment.AddApartmentInDubai")}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}
